var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "5 7 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0007 7.25C18.0448 7.25 21.4093 10.1598 22.1147 14C21.4093 17.8401 18.0448 20.75 14.0007 20.75C9.95658 20.75 6.5921 17.8401 5.88672 14C6.5921 10.1598 9.95658 7.25 14.0007 7.25ZM14.0007 19.25C17.1774 19.25 19.8957 17.039 20.5838 14C19.8957 10.961 17.1774 8.75 14.0007 8.75C10.8239 8.75 8.10565 10.961 7.41757 14C8.10565 17.039 10.8239 19.25 14.0007 19.25ZM14.0007 17.375C12.1367 17.375 10.6257 15.864 10.6257 14C10.6257 12.136 12.1367 10.625 14.0007 10.625C15.8646 10.625 17.3757 12.136 17.3757 14C17.3757 15.864 15.8646 17.375 14.0007 17.375ZM14.0007 15.875C15.0362 15.875 15.8757 15.0355 15.8757 14C15.8757 12.9645 15.0362 12.125 14.0007 12.125C12.9652 12.125 12.1257 12.9645 12.1257 14C12.1257 15.0355 12.9652 15.875 14.0007 15.875Z",
    fill: "#E97A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/viewIcon.f6d4603756c244fb0cca90f1f383e9f4.svg";
export { ForwardRef as ReactComponent };